import { render, staticRenderFns } from "./UserBreadcrumbs.vue?vue&type=template&id=01126990&scoped=true"
import script from "./UserBreadcrumbs.vue?vue&type=script&lang=js"
export * from "./UserBreadcrumbs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01126990",
  null
  
)

export default component.exports